export default function (x, y, object) {
  return !(y < object.top || (object.top + object.height < y) || x < object.left || (object.left + object.width) < x)
}